import { Group, Indicator, Stack, Text, UnstyledButton } from '@mantine/core'
import { useNavigate } from '@tanstack/react-router'
import {
  getNavigationItems,
  NavigationTab,
  useUnreadMessageCount,
} from '../config/navigation'
import styles from './BottomTabNavigator.module.css'

interface BottomTabNavigatorProps {
  activeTab: NavigationTab
}

interface TabButtonProps {
  icon: React.ReactNode
  label: string
  active: boolean
  badge?: number
  onClick: () => void
}

function TabButton({ icon, label, active, badge, onClick }: TabButtonProps) {
  return (
    <UnstyledButton
      onClick={onClick}
      className={styles.tabButton}
      data-active={active}
    >
      <Stack align="center" gap={4}>
        <Indicator
          inline
          label={badge}
          size={16}
          disabled={!badge}
          color="red"
          offset={4}
        >
          <div className={styles.tabIcon} data-active={active}>
            {icon}
          </div>
        </Indicator>
        <Text
          size="xs"
          c={active ? 'brandOrange.6' : 'dimmed'}
          fw={active ? 600 : 400}
        >
          {label}
        </Text>
      </Stack>
    </UnstyledButton>
  )
}

export function BottomTabNavigator({ activeTab }: BottomTabNavigatorProps) {
  const navigate = useNavigate()
  const unreadCount = useUnreadMessageCount()
  const tabs = getNavigationItems(24, unreadCount)

  return (
    <Group gap={0} className={styles.bottomNav}>
      {tabs.map((tab) => (
        <TabButton
          key={tab.id}
          icon={tab.icon}
          label={tab.label}
          active={activeTab === tab.id}
          badge={tab.badge}
          onClick={() => navigate({ to: tab.route })}
        />
      ))}
    </Group>
  )
}
